import { render } from "./CarBadge.vue?vue&type=template&id=13b738c8&scoped=true"
import script from "./CarBadge.vue?vue&type=script&lang=js"
export * from "./CarBadge.vue?vue&type=script&lang=js"

import "./CarBadge.vue?vue&type=style&index=0&id=13b738c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b738c8"]])

export default __exports__